import { CollectionTableDragAndDropContext } from './CollectionTableDragAndDropContext';
import { TableDragAndDrop as WSRTableDragAndDrop } from '@wix/wix-style-react-incubator/drag-and-drop';
import { minimalRequiredWdsRuntimeCheck } from '../minimalRequiredWdsRuntimeCheck';

if (process.env.NODE_ENV !== 'production') {
  minimalRequiredWdsRuntimeCheck({
    required: '^1.64.1',
    requiredBy: 'Cairo/TableDragAndDrop',
  });
}

export const TableDragAndDrop = {
  ...WSRTableDragAndDrop,
  CollectionTableDragAndDropContext,
};
